export default {
   components: {},
   routes: [
      {
         path: '/test-table',
         component: () => import(`./test-table`),
         name: 'TestTable'
      },
      {
         path: '/test-wizard',
         component: () => import(`./test-wizard`),
         name: 'TestWizard'
      },
      {
         path: '/test-data-view',
         component: () => import(`./test-data-view`),
         name: 'TestDataView'
      },
      {
         path: '/test-form',
         component: () => import(`./test-form`),
         name: 'TestForm'
      },
      {
         path: '/test-form-component',
         component: () => import(`./test-form-component`),
         name: 'TestFormComponent'
      },
      {
         path: '/test-advanced-table',
         component: () => import(`./test-advanced-table`),
         name: 'TestFormComponent'
      },
   ]
}